import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import { useDisclosure } from 'components/Dialog';
import { getReuseAvailabilitiesEnabled } from 'domains/appContext/AppContext.store';
import { getReuseAvailabilities } from 'domains/references';
import { REUSE_AVAILABILITIES_ALLOWED_DEALER_TYPES } from 'domains/references/References.types';
import { getDealerType, getUserCountry } from 'domains/user';
import { Text } from 'UI';
import { FOUND } from 'utils';
import { Country } from 'utils/i18n/Country';
import { SReuseAvailabilitiesButton } from './ReuseAvailabilities.styled';
import ReuseAvailabilitiesModal from './ReuseAvailabilitiesModal';

interface ReuseAvailabilitiesButtonProps {
  referenceNumber: string;
}

const ReuseAvailabilitiesButton = ({ referenceNumber }: ReuseAvailabilitiesButtonProps) => {
  const { t } = useTranslation();
  const enabled = useSelector(getReuseAvailabilitiesEnabled);
  const country = useSelector(getUserCountry);
  const dealerType = useSelector(getDealerType);
  const reuseAvailabilities = useSelector((state: RootState) => getReuseAvailabilities(state, referenceNumber));
  const { isOpen, onOpen, onClose } = useDisclosure();

  const isEligibleUser =
    country === Country.FR.key && !!dealerType && REUSE_AVAILABILITIES_ALLOWED_DEALER_TYPES.includes(dealerType);

  if (!enabled || !isEligibleUser || reuseAvailabilities?.searchStatus !== FOUND) {
    return null;
  }

  return (
    <>
      <SReuseAvailabilitiesButton onClick={onOpen} data-cy={'reuse-availabilities-button'}>
        <Text type={'mobile_h3'} ellipsis noWrap>
          {t('catalog.reuse_availabilities.button', 'ReUse offers')}
        </Text>
      </SReuseAvailabilitiesButton>
      <ReuseAvailabilitiesModal
        open={isOpen}
        onClose={onClose}
        referenceNumber={referenceNumber}
        parts={reuseAvailabilities.data ?? []}
      />
    </>
  );
};

export default ReuseAvailabilitiesButton;
